import { API_BASE_URL } from '@/config/env';

export interface RequisitionOption {
  id: number;
  name: string;
  isActive: boolean;
}

export const requisitionOptionsService = {
  getExamTypes: async (token: string): Promise<RequisitionOption[]> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/exam-types`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) throw new Error('Failed to fetch exam types');
    const json = await res.json();
    return json.data || [];
  },
  createExamType: async (
    token: string,
    name: string
  ): Promise<RequisitionOption> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/exam-types`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name }),
      }
    );
    if (!res.ok) throw new Error('Failed to create exam type');
    const json = await res.json();
    return json.data || json;
  },
  updateExamType: async (
    token: string,
    id: number,
    name: string,
    isActive: boolean
  ): Promise<RequisitionOption> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/exam-types/${id}`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, isActive }),
      }
    );
    if (!res.ok) throw new Error('Failed to update exam type');
    const json = await res.json();
    return json.data || json;
  },
  deleteExamType: async (token: string, id: number): Promise<void> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/exam-types/${id}`,
      {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) throw new Error('Failed to delete exam type');
  },

  getOrderReasons: async (token: string): Promise<RequisitionOption[]> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/order-reasons`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) throw new Error('Failed to fetch order reasons');
    const json = await res.json();
    return json.data || [];
  },
  createOrderReason: async (
    token: string,
    name: string
  ): Promise<RequisitionOption> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/order-reasons`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name }),
      }
    );
    if (!res.ok) throw new Error('Failed to create order reason');
    const json = await res.json();
    return json.data || json;
  },
  updateOrderReason: async (
    token: string,
    id: number,
    name: string,
    isActive: boolean
  ): Promise<RequisitionOption> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/order-reasons/${id}`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, isActive }),
      }
    );
    if (!res.ok) throw new Error('Failed to update order reason');
    const json = await res.json();
    return json.data || json;
  },
  deleteOrderReason: async (token: string, id: number): Promise<void> => {
    const res = await fetch(
      `${API_BASE_URL}/admin/requisition-options/order-reasons/${id}`,
      {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) throw new Error('Failed to delete order reason');
  },
};
